import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import moment from 'moment';
import { DisparoService } from '../disparo.service';
import { LoadingModalComponent } from '../../../../loading-modal/loading-modal.component';
import { AlertComponent } from '../../../../alert/alert.component';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-fire-oficial-lista',
  standalone: true,
  imports:[CommonModule, FormsModule, ReactiveFormsModule, MatIconModule, AlertComponent, LoadingModalComponent],
  templateUrl: './fire-oficial-lista.component.html',
  styleUrls: ['./fire-oficial-lista.component.scss'],
  providers: [DisparoService]
})
export class FireOficialListaComponent implements OnInit {

  @Output() closeModal: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(AlertComponent) alertComponent!: AlertComponent;
  @ViewChild(LoadingModalComponent) loadingModalComponent!: LoadingModalComponent;

  //Variaveis de exibicao e configuracao
  public stepForm: number = 1;
  public listChannels: Array<any> = [];
  public listGroup: Array<any>=[];

  //Variaveis para o formulario
  public countrys: Array<any> = [
    { name: 'BRA', code: '55' }, // Brasil
    { name: 'USA', code: '1' },  // Estados Unidos
    { name: 'CAN', code: '1' },  // Canadá
    { name: 'ARG', code: '54' }, // Argentina
    { name: 'MEX', code: '52' }, // México
    { name: 'GBR', code: '44' }, // Reino Unido
    { name: 'FRA', code: '33' }, // França
    { name: 'GER', code: '49' }, // Alemanha
    { name: 'ITA', code: '39' }, // Itália
    { name: 'ESP', code: '34' }, // Espanha
    { name: 'CHN', code: '86' }, // China
    { name: 'JPN', code: '81' }, // Japão
    { name: 'IND', code: '91' }, // Índia
    { name: 'AUS', code: '61' }, // Austrália
    { name: 'ZAF', code: '27' }, // África do Sul
    { name: 'RUS', code: '7' },  // Rússia
    { name: 'KOR', code: '82' }, // Coreia do Sul
    { name: 'SAU', code: '966' },// Arábia Saudita
    { name: 'TUR', code: '90' }, // Turquia
    { name: 'SWE', code: '46' }  // Suécia
  ];
  public columns: Array<any> = [
    { column: 'A', value: 0 },
    { column: 'B', value: 1 },
    { column: 'C', value: 2 },
    { column: 'D', value: 3 },
    { column: 'E', value: 4 },
    { column: 'F', value: 5 },
    { column: 'G', value: 6 },
    { column: 'H', value: 7 },
    { column: 'I', value: 8 },
    { column: 'J', value: 9 },
    { column: 'K', value: 10 },
    { column: 'L', value: 11 },
    { column: 'M', value: 12 },
    { column: 'N', value: 13 },
    { column: 'O', value: 14 },
    { column: 'P', value: 15 },
    { column: 'Q', value: 16 },
    { column: 'R', value: 17 },
    { column: 'S', value: 18 },
    { column: 'T', value: 19 },
    { column: 'U', value: 20 },
    { column: 'V', value: 21 },
    { column: 'W', value: 22 },
    { column: 'X', value: 23 },
    { column: 'Y', value: 24 },
    { column: 'Z', value: 25 },
  ];
  public formOficialQueue: FormGroup;
  public isScheduled: boolean = false;
  public formattedDate: string = "";
  public acceptTerm: boolean = false;

  constructor(private fb: FormBuilder, private disparoService: DisparoService) {
    this.formOficialQueue = this.fb.group({
      idLista: [, [Validators.required]],
      //colunaTelefone: ['0', [Validators.required]],
      idTemplate: ['', [Validators.required]],
      tipodisparo: ['', [Validators.required]],
      data: moment().format('YYYY-MM-DD HH:mm:ss'),
      //ignoreRow: [false],
      canais: this.fb.array([]),
      hComercial: [false],
      sunday: [false]
    })
  }

  ngOnInit() {
    this.getCanais();
    this.getLists();
  }

  /**
   * Funcoes de listagens pela api
   */
  public getCanais() {
    this.disparoService.getCanaisOficial().subscribe((response: any) => {
      this.listChannels = response;
      this.formOficialQueue.patchValue({
        idLista: this.listGroup[0].idlist
      })
    })
  }

  /**
   * Funcoes de listagem de listas
   */

  public getLists(){
    this.disparoService.getListas().subscribe((response:any)=> {
      this.listGroup = response;
    })
  }

  /**
   * Funcao para fechar o modal
   */
  public handleCloseModal(value: number) {
    this.closeModal.emit(value);
  }

  /**
   * Funcoes de avancar e retornar
   */
  public nextStep(): void {
    console.log(this.formOficialQueue.value);
    if (this.stepForm < 3) {
      this.stepForm++;
    }
  }

  public previousStep(): void {
    if (this.stepForm > 1) {
      this.stepForm--;
    }
  }

  /**
   * Funcao para adicionar arquivo e converter em base64
   */

  handleAddCsvFile(event: Event) {
    const reader = new FileReader();
    const file = (event?.target as HTMLInputElement).files?.[0];
    if (file) {

      console.log('carregando arquivo csv');
      reader.onload = () => {
        if (typeof reader.result === 'string') {

          this.formOficialQueue.patchValue({
            csv: this.removeMimeType(reader.result)
          })
        }
      }
      reader.readAsDataURL(file); // Lê o arquivo como Base64

    }
  }

  public removeMimeType(base64String: string): string {
    // Localiza a posição do delimitador `,` e retorna o conteúdo após ele
    return base64String.substring(base64String.indexOf(',') + 1);
  }

  /**
   * Funcoes para selecao de canais
   */
  public handleSelectChannel(event: Event) {
    const eventCapture: any = (event?.target as HTMLInputElement)

    if (eventCapture.checked === true) {
      console.log("Marcou");
      console.log(eventCapture.value);
      this.formOficialQueue.value.canais.push(eventCapture.value)
    }

    if (eventCapture.checked === false) {
      console.log("Desmarcou")
      console.log(eventCapture.value);
      this.formOficialQueue.value.canais.splice(this.formOficialQueue.value.canais.indexOf(eventCapture.value), 1);
    }
  }

  /**
   * Funcoes de manipulacao de personalizacao do envio
   */

  public handleIsScheduled(event: Event): void {
    const data: any = (event?.target as HTMLInputElement).checked;

    if (data === true) {
      this.isScheduled = true;
      this.formOficialQueue.get('tipodisparo')?.setValue('AGENDADO');
      return;
    }

    this.formOficialQueue.patchValue({
      data: moment().format('YYYY-MM-DD HH:mm:ss')
    })
    this.isScheduled = false;
    this.formOficialQueue.get('tipodisparo')?.setValue('NORMAL');
  }

  public handleManualyTimeData(event: Event): void {
    const hourNow: string = (event?.target as HTMLInputElement)?.value;

    const segmentHours: any = hourNow.split(' ');

    const [hour, minutes] = hourNow.split(':');

    console.log("Horas: ", hour);
    console.log("Minutes: ", minutes);

    this.formOficialQueue.patchValue({
      data: moment(this.formOficialQueue.get('data')?.value, 'YYYY-MM-DD HH:mm:ss').hour(parseInt(hour)).minute(parseInt(minutes)).seconds(0).format('YYYY-MM-DD HH:mm:ss')
    })

    console.log('Nova Data: ', this.formOficialQueue.get('data')?.value);

  }

  public handleManualyDateData(event: Event): void {
    const dateSelected: string = (event?.target as HTMLInputElement)?.value;

    this.formattedDate = dateSelected;
    const [year, month, day] = dateSelected.split('-');

    console.log(`Ano ${year}, Mes: ${month}, Dia: ${day}`);

    this.formOficialQueue.patchValue({
      data: moment(this.formOficialQueue.get('data')?.value, 'YYYY-MM-DD HH:mm:ss').date(parseInt(day)).month(parseInt(month) - 1).year(parseInt(year)).format('YYYY-MM-DD HH:mm:ss')
    });
  }

  /**
   * Funcoes para validar os steps
   */
  public handleValidStepOne(): boolean {
    if (!this.formOficialQueue.value.idLista || !this.formOficialQueue.value.idTemplate) return false;

    return true;
  }

  public handleValidStepTwo(): boolean {
    if (this.formOficialQueue.value.canais.length === 0) return false;

    return true;
  }

  public handleValidStepThree(): boolean {
    if (!this.acceptTerm) return false;

    return true;
  }

  public handleSubmitFire() {
    console.log(this.formOficialQueue.value);
    this.loadingModalComponent.activeLoading();
    this.disparoService.setDisparoQueueOficial(this.formOficialQueue.value).subscribe((response: any) => {
      this.alertComponent.showAlert("Disparo criado com sucesso!", 'success');
      setTimeout(() => {
        this.loadingModalComponent.inactiveLoading();
        this.handleCloseModal(2);
      }, 500);
    }, (error: any) => {
      console.log(error);
      this.loadingModalComponent.inactiveLoading();
      this.alertComponent.showAlert(`Erro ao criar disparo: ${error.error.status}`, 'error');
    })
  }

}
